import { BarChart3, CalendarDays, Code2, Layers, Megaphone, Monitor, MonitorPlay, Package, Plug, Settings2, Stethoscope, Store, Users, UtensilsCrossed, Wrench, type LucideIcon } from 'lucide-react'
import type { ModuleCategory, ProjectColor, ProjectIconKey, Severity, TaskStatus, TaskType } from './types'

export const PROJECT_ICON: Record<ProjectIconKey, LucideIcon> = {
  monitor: Monitor,
  users: Users,
  calendar: CalendarDays,
  stethoscope: Stethoscope,
  store: Store,
  utensils: UtensilsCrossed,
  package: Package,
}

export const PROJECT_COLOR: Record<ProjectColor, string> = {
  navy: 'bg-brand-navy text-white',
  blue: 'bg-brand-blue text-white',
  violet: 'bg-violet text-white',
  orange: 'bg-brand-orange text-white',
  green: 'bg-success text-white',
}

/** Görev durumları için nokta/sütun renkleri (kanban başlığı, takvim çipi, lejant). */
export const TASK_STATUS_DOT: Record<TaskStatus, string> = {
  todo: 'bg-muted-foreground/60',
  in_progress: 'bg-info',
  review: 'bg-warning',
  approval: 'bg-violet',
  done: 'bg-success',
}

export const TASK_STATUS_COLUMN: Record<TaskStatus, string> = {
  todo: 'bg-muted/40',
  in_progress: 'bg-info/[0.05]',
  review: 'bg-warning/[0.07]',
  approval: 'bg-violet/[0.06]',
  done: 'bg-success/[0.06]',
}

/** Blocker önem derecesine göre ikon kutusu tonu. */
export const SEVERITY_TONE: Record<Severity, string> = {
  high: 'bg-destructive/10 text-destructive',
  medium: 'bg-warning/10 text-warning',
  low: 'bg-muted text-muted-foreground',
}

export const TASK_TYPE_ICON: Record<TaskType, LucideIcon> = { development: Code2, installation: Wrench, demo: MonitorPlay }

export const MODULE_CATEGORY_ICON: Record<ModuleCategory, LucideIcon> = { core: Layers, operations: Settings2, integration: Plug, reporting: BarChart3, marketing: Megaphone }

export const MODULE_CATEGORY_TONE: Record<ModuleCategory, string> = {
  core: 'bg-primary/10 text-primary',
  operations: 'bg-success/12 text-success',
  integration: 'bg-violet/12 text-violet',
  reporting: 'bg-info/12 text-info',
  marketing: 'bg-brand-orange/12 text-brand-orange',
}
